import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { Services } from './Services.js';
import { servicesProviderCoverageFulfillmentDataSchema } from './ServicesProviderCoverageFulfillmentData.js';
import { PayableServicesProvider } from './ServicesProviderPayable.js';

class ServicesProviderCoverageFulfillment extends PayableServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
    }
    validateData(data) {
        const result = servicesProviderCoverageFulfillmentDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderCoverageFulfillment.validation', `ServicesProviderCoverageFulfillment data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.COVERAGE_FULFILLMENT,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.COVERAGE_FULFILLMENT, ServicesProviderCoverageFulfillment);

export { ServicesProviderCoverageFulfillment };
//# sourceMappingURL=ServicesProviderCoverageFulfillment.js.map
